/* @flow */
const prefix = str => `station/features/${str}`;

export const SPLIT_SDK_READY = prefix('SPLIT_SDK_READY');
export const SPLIT_SDK_UPDATE = prefix('SPLIT_SDK_UPDATE');
export const SPLIT_SDK_READY_TIMED_OUT = prefix('SPLIT_SDK_READY_TIMED_OUT');

export const FEATURES_UPDATED = prefix('FEATURES_UPDATED');



// WEBPACK FOOTER //
// ./src/app/modules/features/action-types.js